import React, { useEffect, useRef } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { useSnackbar } from "notistack"
import { useIntl } from "react-intl"

import { isPermittedPermission } from "./../../helpers"
import { ContentRoute } from "../router"


const ProtectedDialogRoute = ({
  isAuthenticated = false,
  anonymous = true,
  can,
  isSuperuser,
  permissions,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const intl = useIntl()
  const toastFired = useRef(false)

  const needsAuth = !isAuthenticated && !anonymous
  const lacksPermission =
    isAuthenticated && !isSuperuser && !isPermittedPermission(can, permissions)

  useEffect(() => {
    if (lacksPermission && !toastFired.current) {
      toastFired.current = true
      enqueueSnackbar(
        intl.formatMessage({
          id: "ERROR.FORBIDDEN.SUB_TITLE",
          defaultMessage: "Vous n'avez pas accès à cette page.",
        }),
        {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 4000,
        }
      )
    }
  }, [lacksPermission, enqueueSnackbar, intl])

  if (needsAuth) return <Redirect to="/auth/login" />
  if (lacksPermission) return <Redirect to="/" />

  return (<ContentRoute {...props} />)
}


const mapStateToProps = (state) => state.common.auth

export default connect(mapStateToProps)(ProtectedDialogRoute)
